import React from 'react';
import Navbar from '../components/landing/Navbar';
import MoroccoVideoHero from '../components/landing/MoroccoVideoHero';
import AppExperience from '../components/landing/AppExperience';
import SuperAppServices from '../components/landing/SuperAppServices';
import WaitlistSection from '../components/landing/WaitlistSection';
import Footer from '../components/landing/Footer';
import { LandingLanguageProvider } from '../context/LandingLanguageContext';

const LandingPage = () => {
  return (
    <LandingLanguageProvider>
      <div
        style={{
          background: '#0F0F0F',
          minHeight: '100vh',
          overflowX: 'visible',
          width: '100%',
          maxWidth: '100%',
          fontFamily: 'Inter, system-ui, sans-serif',
        }}
      >
        <Navbar />
        <MoroccoVideoHero />
        <AppExperience />
        <SuperAppServices />
        <WaitlistSection />
        <Footer />
      </div>
    </LandingLanguageProvider>
  );
};

export default LandingPage;
